import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RfeTabComponent } from './components/rfe-tab/rfe-tab.component';
import { TaskSummaryTabComponent } from './components/task-summary-tab/task-summary-tab.component';
import { SuperTaskSummaryComponent } from './components/superTask-summary/superTask-summary.component';
import { SuperTaskSummaryResolver } from '../utility/superTaskSummaryResolver';
//import { CreateTaskComponent } from './components/create-task/create-task.component';
import { CreateTaskNewComponent } from './components/create-task-new/create-task-new.component';
import { DirtyFormGuard } from 'src/app/dirty-form.guard';
import { TaskDetailsNewComponent } from './components/task-details-new/task-details-new.component';
import { TimelineStepComponent } from './components/timeline-step/timeline-step.component';
import { PetitionStatusComponent } from './components/petition-status/petition-status.component';
import { DocumentChecklistComponent } from './components/document-checklist/document-checklist.component';

const routes: Routes = [
  {
    path: 'task-details',
    component: SuperTaskSummaryComponent,
    resolve: { taskDetails: SuperTaskSummaryResolver },
    children: [
      { path: '', redirectTo: 'summary', pathMatch: 'full' },
      { path: 'summary', component: TaskSummaryTabComponent },
      // {
      // path: 'petition',
      // loadChildren: () => import('../petition-builder/petition-builder.module').then((mod) => mod.PetitionBuilderModule)
      // },
      { path: 'rfe', component: RfeTabComponent },
      {
        path: 'I-140',
        loadChildren: () => import('../green-card-i140/green-card-i140.module').then((module) => module.GreenCardI140Module)
      },
      {
        path: 'visa/:visaType',
        loadChildren: () => import('../l1-visa/l1.module').then((module) => module.L1Module)
      },
      {
        path: 'immigration/:taskType',
        loadChildren: () => import('../l1-visa/l1.module').then((module) => module.L1Module)
      },
      {
        path: 'green-card',
        loadChildren: () => import('../green-card/green-card.module').then((mod) => mod.GreenCardModule)
      }
    ]
  },
  // {
  //   path: 'new', component: CreateTaskComponent
  // },
  {
    path: 'new', component: CreateTaskNewComponent,
    canDeactivate: [ DirtyFormGuard ]
  },
  {
    path: 'task-overview', component: TaskDetailsNewComponent,
    resolve: { taskDetails: SuperTaskSummaryResolver },
    children: [
      {
        path: 'petition-status',
        component: PetitionStatusComponent
      },
      {
        path: 'beneficiary-timeline',
        component: TimelineStepComponent
      },
      {
        path: 'beneficiary-document-checklist',
        component: DocumentChecklistComponent
      },
      { 
        path: '', 
        redirectTo: 'petition-status', 
        pathMatch: 'full' 
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SuperTaskRoutingModule { }
